import API from '../../api/api';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import '../../styles/css/passwords/passwordReset.css';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formInputs: {},
            errors: {},
            formStatus: {
                message: "",
                status: ""
            },
            showEmailSent: false,
            loading: false,
        };

        this.catchInputChange = this.catchInputChange.bind(this);
        this.doSubmit = this.doSubmit.bind(this);
    }

    catchInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const formInputs = this.state.formInputs;
        formInputs[name] = value;

        this.setState({
            formInputs: formInputs
        });
    }

    doSubmit(event) {
        event.preventDefault();
        this.setState({
            loading: true
        });
        this.handleForgotPassword();
    }

    handleForgotPassword() {
        API.post(`user/forgot_password`, this.state.formInputs)
            .then(res => {
                console.log(res, "success");
                this.setState({
                    errors: {},
                    formStatus: {
                        message: res.data.response,
                        status: "alert alert-success"
                    },
                    showEmailSent: true,
                    loading: false,
                });
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.setState({
                    errors: err.response.data.error,
                    formStatus: {
                        message: err.response.data.message,
                        status: "alert alert-danger"
                    },
                    loading: false,
                });
            })
    }

    openPanel() {
        document.getElementById("resetPanel").style.opacity = "1";
    }

    render() {
        const {classes} = this.props;
        return (
            <div onLoad={this.openPanel} className={`${classNames(classes.session)} mainDiv`}>
                <img className="common_updots" src="/static/images/common_updots.svg" alt="common_updots"/>
                <img className="common_downdots" src="/static/images/common_downdots.svg" alt="common_downdots"/>
                <div className={classes.content}>
                    <div className={classes.wrapper}>
                        <Card className="resetPanel" id="resetPanel">
                            <CardContent className={!this.state.showEmailSent ? classes.hidden : ''}>
                                <div className="text-xs-center pb-xs">
                                    <h1 className="resetPwordHead">Email Sent</h1>
                                    <Typography className="resetPwordSub" variant="body1">
                                        An email with instructions on how to reset your password has been sent
                                        to {this.state.formInputs.email ? this.state.formInputs.email : ''}
                                    </Typography>
                                    <Typography className="resetPwordSub" variant="body1">
                                        Check your spam or junk folder if you don't see the email in your inbox.
                                    </Typography>
                                    <div className="pt-1 text-xs-center alreadyAcc">
                                        <span>Already have an account?&nbsp;</span>
                                        <Link className="" to="/signin">Sign in</Link>
                                    </div>
                                </div>
                            </CardContent>
                            <CardContent className={this.state.showEmailSent ? classes.hidden : ''}>
                                <form onSubmit={this.doSubmit}>
                                    <div className="text-xs-center pb-xs">
                                        <h1 className="resetPwordHead">Reset password</h1>
                                        <div className={this.state.formStatus.status}>
                                            {this.state.formStatus.message}
                                        </div>
                                        <Typography className="resetPwordSub" variant="caption">Enter your email and
                                            we'll send you instructions on how to reset your password.</Typography>
                                        <CircularProgress className={this.state.loading ? '' : classes.hidden}/>
                                    </div>
                                    <TextField
                                        id="email"
                                        name="email"
                                        label="Email"
                                        className={`${classes.textField} resetLabel ${this.state.errors.email ? 'loginInput' : ''}`}
                                        fullWidth
                                        margin="normal"
                                        onChange={this.catchInputChange}
                                        helperText={this.state.errors.email ? this.state.errors.email[0] : ''}
                                    />
                                    <input className="resetBtn" value="Send password reset link" type="submit"/>
                                    <div className="pt-1 text-xs-center alreadyAcc">
                                        <span>Already have an account?&nbsp;</span>
                                        <Link className="" to="/signin">Sign in</Link>
                                    </div>
                                </form>
                            </CardContent>
                        </Card>
                    </div>
                </div>
            </div>
        );
    }
}

ForgotPassword.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/pages/Users/ForgotPassword.js